import { gql } from 'graphql-request'
import {
  ServerMutationRootPaySalaryArgs,
  ServerPaySalaryResult,
} from '../../generated/graphql-types'
import { request, useMutation } from '../../api'
import { invalidateOnPaySalary } from './logic'

export function usePaySalary() {
  return useMutation(
    async (
      dto: ServerMutationRootPaySalaryArgs,
    ): Promise<{
      paySalary: ServerPaySalaryResult
    }> => {
      return await request(
        gql`
          mutation (
            $accountId: Int!
            $startPeriod: timestamptz!
            $endPeriod: timestamptz!
            $salaryRateIssues: [SalaryRateIssue!]!
            $employeeIds: [Int!]!
          ) {
            paySalary(
              accountId: $accountId
              startPeriod: $startPeriod
              endPeriod: $endPeriod
              salaryRateIssues: $salaryRateIssues
              employeeIds: $employeeIds
            ) {
              success
            }
          }
        `,
        dto,
      )
    },
    {
      onSuccess: invalidateOnPaySalary,
    },
  )
}
